<template>
  <el-dialog title="业务入库批次拣配" :visible.sync="defaultVisible" width="1200px">
    <sirui-search
      v-if="searchColumns.length"
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    ></sirui-search>
    <div class="main-content">
      <div class="m-b">
        <span>待拣配数量：{{ toPickedAmount }}</span>
        <span>已拣配数量：{{ hasPickedAmount }}</span>
      </div>
      <sirui-table
        :rowKey="propCode || 'id'"
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="page"
        :checkRowKeys="checkRowKeys"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handlePagination"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-if="isMultiple"
          type="checkbox"
          width="50"
          fixed="left"
        ></vxe-table-column>
        <vxe-table-column v-else type="radio" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.prop"
          :title="item.label"
          :sortable="item.sortable"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'pickingQuantity'">
              <input-number
                v-model="scope.row.pickingQuantity"
                :max="scope.row.availableSaleQuantityChange"
                :precision="8"
                @input="(val) => pickingQuantityChange(val, scope.row, scope)"
              ></input-number>
            </span>
            <span v-else-if="item.prop == 'availableSaleQuantityChange'">{{
              scope.row['availableSaleQuantityChange'].toFixed(8)
            }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('salesBill.message.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{
        $t('salesBill.message.confirm')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { filterEmpty } from '@/common/js/util';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import inputNumber from '@/components/form-item/input-number';
  import Big from 'big.js';
  export default {
    props: {
      basicData: {
        type: Object,
        default: () => {},
      },
      storageLadingPickingDetailList: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      SiruiSearch,
      SiruiTable,
      inputNumber,
    },
    data() {
      return {
        defaultVisible: false,
        load: false,
        tableData: [],
        tableDataSelected: [], //用于存储每一页临时填写的记录
        query: {},
        multipleSelection: [],
        propCode: '',
        page: true,
        checkRowKeys: [],
        isMultiple: true,
        hasPickedAmount: 0,
        toPickedAmount: 0,
        totalToPickedAmount: 0,
        chooseIndex: '', //拣配的商品明细的行序号
        productNo: '',
        productDesc: '',
        businessLadingAmount: 0, //提单金额
        actualSendQuantity: 0, //实发数量
      };
    },
    computed: {
      searchColumns() {
        // const departmentUrl = this.companyCode
        //   ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${this.companyCode}`
        //   : '';
        return [
          {
            type: 'input',
            prop: 'ladingBusinessDepartmentName',
            name: this.$t('salesBill.batchPickingDialog.search.ladingBusinessDepartmentName'),
            disabled: true,
          },
          {
            type: 'input',
            prop: 'storageName',
            name: this.$t('salesBill.batchPickingDialog.search.storageName'),
            disabled: true,
          },
          {
            type: 'input',
            prop: 'productDesc',
            name: this.$t('salesBill.batchPickingDialog.search.productDesc'),
            disabled: true,
          },
          {
            type: 'input',
            prop: 'identifyingCode',
            name: this.$t('salesBill.batchPickingDialog.search.identifyingCode'),
          },
          {
            type: 'startDaterangePicker',
            prop: 'startGmtCreate',
            name: this.$t('salesBill.batchPickingDialog.search.startGmtCreate'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'endGmtCreate',
            name: this.$t('salesBill.batchPickingDialog.search.endGmtCreate'),
          },
          {
            type: 'input',
            prop: 'contractInternalNo',
            name: this.$t('salesBill.batchPickingDialog.search.contractInternalNo'),
          },
          {
            type: 'input',
            prop: 'batchNo',
            name: this.$t('salesBill.batchPickingDialog.search.batchNo'),
          },
          {
            type: 'input',
            prop: 'inboundNo',
            name: this.$t('salesBill.batchPickingDialog.search.inboundNo'),
          },
          {
            type: 'input',
            prop: 'partnerName',
            name: this.$t('salesBill.batchPickingDialog.search.partnerName'),
          },
          /* {
            type: 'input',
            prop: 'marineLadingNo',
            name: this.$t('salesBill.batchPickingDialog.search.marineLadingNo'),
          },
          {
            type: 'input',
            prop: 'warehouseReceiptsNo',
            name: this.$t('salesBill.batchPickingDialog.search.warehouseReceiptsNo'),
          }, */
          {
            type: 'input',
            prop: 'settleBatchNo',
            name: this.$t('salesBill.batchPickingDialog.search.settleBatchNo'),
          },
          /* {
            type: 'input',
            prop: 'distributionBatchNo',
            name: this.$t('logistics.commodityMarket.distributionBatchNo'),
          },
          {
            type: 'input',
            prop: 'nameVoyageLicense',
            name: this.$t('salesBill.batchPickingDialog.search.storageBatch'),
          },
          {
            type: 'input',
            prop: 'orderNo',
            name: this.$t('salesBill.batchPickingDialog.search.orderNo'),
          }, */
          {
            type: 'input',
            prop: 'supplychainName',
            name: this.$t('salesBill.batchPickingDialog.search.supplychainName'),
          },
          {
            type: 'inputNumber',
            prop: 'availableQuantity',
            name: '库存数量',
          },
          {
            type: 'input',
            prop: 'carNo',
            name: '车牌号',
          },
          {
            type: 'input',
            prop: 'externalContractNo',
            name: '外部合同号',
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'batchNo',
            label: this.$t('salesBill.batchPickingDialog.table.batchNo'),
            fixed: 'left',
          },
          {
            prop: 'storageQuantity',
            label: this.$t('salesBill.batchPickingDialog.table.storageQuantity'),
            fixed: 'left',
          },
          { prop: 'productName', label: this.$t('salesBill.batchPickingDialog.table.productName') },
          /* { prop: 'distributionBatchNo', label: '物流批次号' }, */
          {
            prop: 'availableSaleQuantityChange',
            label: '可售数量',
          },
          {
            prop: 'pickingQuantity',
            label: this.$t('salesBill.batchPickingDialog.table.pickingQuantity'),
          },
          { prop: 'storageName', label: this.$t('salesBill.batchPickingDialog.table.storageName') },
          { prop: 'inboundDate', label: this.$t('salesBill.batchPickingDialog.table.inboundDate') },
          { prop: 'partnerName', label: this.$t('salesBill.batchPickingDialog.table.partnerName') },
          {
            prop: 'businessUnitPriceWithTax',
            label: this.$t('salesBill.batchPickingDialog.table.businessUnitPriceWithTax'),
          },
          {
            prop: 'contractInternalNo',
            label: this.$t('salesBill.batchPickingDialog.table.contractInternalNo'),
          },
          {
            prop: 'externalContractNo',
            label: '外部合同号',
          },
          { prop: 'inboundNo', label: this.$t('salesBill.batchPickingDialog.table.inboundNo') },
          {
            prop: 'supplychainName',
            label: this.$t('salesBill.batchPickingDialog.table.supplychainName'),
          },
          {
            prop: 'settleBatchNoForShow',
            label: this.$t('salesBill.batchPickingDialog.table.settleBatchNo'),
          },
          {
            prop: 'identifyingCode',
            label: this.$t('salesBill.batchPickingDialog.table.identifyingCode'),
          },
          {
            prop: 'carNo',
            label: '车牌号',
            // fixed: 'left',
          },
          {
            prop: 'spec',
            label: '规格',
            // fixed: 'left',
          },
          {
            prop: 'documentNo',
            label: '纸质单据号',
            // fixed: 'left',
          },
          // {
          //   prop: 'netWeight',
          //   label: '净重',
          //   // fixed: 'left',
          // },
          // {
          //   prop: 'deduct',
          //   label: '扣杂',
          //   // fixed: 'left',
          // },
          /* {
            prop: 'distributionBatchNo',
            label: this.$t('logistics.commodityMarket.distributionBatchNo'),
          },
          { prop: 'orderNo', label: this.$t('salesBill.batchPickingDialog.table.orderNo') },
          {
            prop: 'nameVoyageLicense',
            label: this.$t('salesBill.batchPickingDialog.search.storageBatch'),
          },
          {
            prop: 'financeUnitPriceWithTax',
            label: this.$t('salesBill.batchPickingDialog.table.financeUnitPriceWithTax'),
          },
          {
            prop: 'marineLadingNo',
            label: this.$t('salesBill.batchPickingDialog.table.marineLadingNo'),
          },
          {
            prop: 'warehouseReceiptsNo',
            label: this.$t('salesBill.batchPickingDialog.table.warehouseReceiptsNo'),
          }, */
          /* { prop: "settleBatchNo", label: this.$t("salesBill.batchPickingDialog.table.settleBatchNo") }, */
        ];
      },
    },
    mounted() {
      this.initQuery();
    },
    methods: {
      // 初始化查询参数
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string') {
              query[item.prop] = undefined;
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, query, this.query);
      },
      getData() {
        if (!API) return;
        this.load = true;
        const query = this.getQuery();
        if (this.$route.query.ladingNo && !this.$route.query.copy) {
          query.ladingNo = this.$route.query.ladingNo;
        }
        query.productDesc = null;
        query.isMoreZero = 1;
        query.availableIsMoreZero = 1;
        delete query.storageName;
        this.$axios
          .post(API.LIST_BUSINESS_IN_API, filterEmpty(query))
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              if (this.page) {
                this.tableData = res.data.data.list;

                //拣配进来时先判断是否有对应的拣配结果，如果有那么就要加上对应提单行和批次号的拣配数量
                this.tableData.forEach((item) => {
                  this.storageLadingPickingDetailList.filter((it) => {
                    //新的拣配行拣配进来时初始化可售数量数据
                    if (it.businessInboundBatchNo == item.batchNo) {
                      item.availableQuantity -= it.pickingQuantity;
                    }
                  });
                });
                this.tableData.forEach((item) => {
                  this.storageLadingPickingDetailList.filter((it) => {
                    //已经拣配过重新拣配进来时初始化可售数量数据
                    if (
                      this.chooseIndex == it.ladingDetailNo &&
                      it.businessInboundBatchNo == item.batchNo
                    ) {
                      item.availableQuantity += it.pickingQuantity;
                    }
                  });
                });
                this.tableData.map((item) => {
                  item.availableSaleQuantityChange = item.storageQuantity;
                  // this.$cal.calCommon(
                  //   item.availableQuantity,
                  //   0,
                  //   '+',
                  //   'quantity'
                  // );
                });
                //翻页时取已经赋值的记录覆盖每一页对应的数据
                this.tableData.forEach((item) => {
                  this.tableDataSelected.filter((it) =>
                    it.id == item.id ? (item.pickingQuantity = it.pickingQuantity) : null
                  );
                });
                this.$refs.siruiTable.setPageTotal(res.data.data.total);
              } else {
                this.tableData = res.data.data;
              }
              /* Promise.resolve(this.getCheckout(this.tableData)).then(res=>{
              this.tableData = res;
            }) */
              //   if (res.length) {
              //     Promise.resolve(this.getCheckout2(res)).then(item=>{
              //         this.tableData = item;
              //     })
              //   }
              // })
              //重新加载表格
              // this.$refs.siruiTable.reloadTable(this.tableData);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      getCheckout(tableData) {
        return new Promise((resolve) => {
          tableData.forEach((item) => {
            this.$axios.post(API.GET_ORDER, { contractNo: item.contractInternalNo }).then((res) => {
              item.ladingCurrency = res.data.data.contractCurrency; //币种类型
            });
          });
          resolve(tableData);
        });
      },
      // getCheckout2(tableData){
      //     return new Promise((resolve, reject) => {
      //        tableData.forEach(item=>{
      //         let params = {
      //           fromCurrencyCode:item.ladingCurrency,
      //           toCurrencyCode:this.basicData.ladingCurrency,
      //           contractUnitPrice:item.businessUnitPriceWithTax
      //         }
      //         this.$axios.post(API.GET_EXCHANGE_CURRENCY,params).then(res=>{
      //             if(res.data.code == 0){
      //               item.businessUnitPriceWithTax = res.data.data.contractUnitPrice;
      //             }
      //         })
      //        })
      //        resolve(tableData);
      //     })
      // },
      // 弹窗确认
      handleConfirm() {
        if (this.toPickedAmount != 0) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.quantityMatch'),
            type: 'error',
          });
          return;
        }
        // let tableData = this.$refs.siruiTable.data;
        let resultArr = [];
        this.tableDataSelected.map((item) => {
          if (item.pickingQuantity && item.pickingQuantity != 0) {
            // const result = {
            //   fromCurrencyCode:item.ladingCurrency,
            //   businessUnitPriceWithTax:item.businessUnitPriceWithTax,
            //   selectNum:item.pickingQuantity,
            //   ladingDetailNo: this.chooseIndex,
            //   productDesc: this.productDesc,
            //   productNo: this.productNo,
            //   ladingUnit: this.ladingUnit,
            //   ladingUnitName: this.ladingUnitName,
            //   supplier: item.partnerName,
            //   businessContractUnitPrice: item.businessUnitPriceWithTax,
            //   pickingQuantity: item.pickingQuantity,
            //   businessInboundBatchNo: item.batchNo,
            //   contractInternalNo:item.contractInternalNo
            // };
            item.productNo = item.productDetailNo;
            item.ladingDetailNo = this.chooseIndex;
            item.fromCurrencyCode = item.ladingCurrency;
            item.businessLadingAmount = this.businessLadingAmount;
            resultArr.push(item);
          }
        });
        //拣配金额转换
        let params = {
          toCurrencyCode: this.basicData.ladingCurrency,
          storageBatchList: resultArr,
        };
        this.$axios
          .post(API.GET_EXCHANGE_CURRENCY, params)
          .then((res) => {
            if (res.data.data) {
              res.data.data.storageBatchList.forEach((it) => {
                it.businessLadingAmount = this.businessLadingAmount;
                it.actualSendQuantity = this.actualSendQuantity;
              });
              resultArr = res.data.data.storageBatchList;
              this.$emit('changeResult', resultArr);
            }
          })
          .finally(() => {
            this.defaultVisible = false;
          });
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      // 获取查询参数
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, this.extraData, query, {
          pageNum,
          pageSize,
        });
        console.log(this.searchColumns);
        this.searchColumns.forEach((item) => {
          if (item.getSearchCode) {
            const arr = query[item.prop];
            if (arr && arr.length) {
              const codes = arr.map((code) => {
                return code[item.getSearchCode];
              });
              // 单选改第一个，多选给多个
              result[item.prop] = item.isMultiple ? codes[0] : codes;
            }
          }
        });
        return result;
      },
      // 点击分页
      handlePagination() {
        this.getData();
      },
      // 分页条数改变
      handleSizeChange() {
        this.getData();
      },
      // 搜索
      search() {
        this.$refs.siruiTable?.setPageNum(1);
        this.$refs.siruiTable?.clearCheckboxReserve();
        //初始化数据
        this.tableDataSelected = [];
        this.hasPickedAmount = 0;
        // this.toPickedAmount = this.$cal.calCommon(
        //   this.totalToPickedAmount,
        //   this.hasPickedAmount,
        //   '+',
        //   'quantity'
        // );
        this.getData();
      },
      // 表格选中行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        //初始化数据
        this.tableDataSelected = [];
        this.hasPickedAmount = 0;
        // this.toPickedAmount = this.$cal.calCommon(
        //   this.totalToPickedAmount,
        //   this.hasPickedAmount,
        //   '+',
        //   'quantity'
        // );
        this.getData();
      },
      //从外面选择行 做为拣配搜索的默认条件 如 商品 仓库 部门
      chooseGoods(row, chooseIndex, baseInfo) {
        console.log(row, chooseIndex, baseInfo, '????===>');
        this.defaultVisible = true;
        this.query.productDesc = row[0].productDesc;
        // this.query.ladingBusinessDepartmentName = row[0].contractBusinessDepartmentName || row[0].departmentName;
        this.query.ladingBusinessDepartmentName = this.basicData.ladingBusinessDepartmentName;
        this.toPickedAmount = row[0].ladingQuantity; //默认带过来的待拣配数量等于提单数量
        this.hasPickedAmount = 0; // 已拣配数量为0
        this.totalToPickedAmount = row[0].ladingQuantity; //默认带过来的待拣配数量等于提单数量 开始的总待提单数量
        this.businessLadingAmount = row[0].businessLadingAmount; //默认带过来的待拣配数量等于提单数量 开始的总待提单数量
        // //默认带三个固定条件
        this.query.batchDepartmentNo =
          row[0].contractBusinessDepartment || baseInfo.ladingBusinessDepartmentNo;
        this.query.storageName = baseInfo.storageName || '';
        this.query.storageNo = baseInfo.storageNo || '';
        this.query.productDetailNo = row[0].productNo;
        this.chooseIndex = chooseIndex;
        this.productNo = row[0].productNo || '';
        this.productDesc = row[0].productDesc || '';
        this.ladingUnit = row[0].ladingUnit || '';
        this.ladingUnitName = row[0].ladingUnitName || '';
        this.actualSendQuantity = row[0].ladingQuantity; //默认带过来的待拣配数量等于提单数量
        setTimeout(() => {
          // 进入弹窗查询数据
          this.search();
        }, 300);
      },
      //批次行拣配数量发生变化
      pickingQuantityChange(val, row, scope) {
        console.log(val, row, scope);
        //clearTimeout(this.timeout)
        // this.timeout = setTimeout(() => {
        //row.availableSaleQuantityChange = row.availableQuantity - Number(val);//每行可售数量减少
        // row.availableSaleQuantityChange =this.$cal.accSub(row.availableSaleQuantity,val)//每行可售数量减少
        // row.availableSaleQuantityChange=XEUtils.toFixedNumber(row.availableSaleQuantityChange, 3);
        // let tableData = this.$refs.siruiTable.data;
        this.tableDataSelected.splice(
          this.tableDataSelected.findIndex((it) => it.id === row.id),
          this.tableDataSelected.findIndex((it) => it.id === row.id) > -1 ? 1 : 0
        );
        this.tableDataSelected.push(row);
        this.hasPickedAmount = this.tableDataSelected
          .map((item) => item.pickingQuantity)
          .reduce((x, y) => {
            return this.$cal.calCommon(x, y, '+');
          });
        this.toPickedAmount = new Big(this.totalToPickedAmount)
          .minus(this.hasPickedAmount)
          .toFixed(8);
        /* let tableData = this.$refs.siruiTable.data;
        const addNum=[]
        tableData.forEach(item => {
          addNum.push(item.pickingQuantity||0)
        })
        Promise.resolve(this.calculateAdd(addNum)).then(res => {
          this.hasPickedAmount=res
          this.toPickedAmount = this.$cal.accSub(this.totalToPickedAmount, this.hasPickedAmount)
          this.toPickedAmount=XEUtils.toFixedNumber(this.toPickedAmount, 3);
        });*/
        // }, 1000)
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
    },
  };
</script>
